module.exports = __webpack_public_path__ + "img/logo_grsm_m.d3c26d5c.png";